export const loginGetters = {
  /* ****************A*I********************* */

  getMsalInstance(state) {
    return state.msalInstance
  },
  getIsAuthenticated(state) {
    return state.isAuthenticated
  },
  getIsInitialized(state) {
    return state.isInitialized
  },
  getAccessToken(state) {
    return state.accessToken
  },
  getIDToken(state) {
    return state.idToken
  },
  getIsLoggedIn(state) {
    return state.isLoggedIn
  },
  getExpires(state) {
    return state.expires
  },
  getUserName(state) {
    return state.userName
  },
  getUserEmail(state) {
    return state.userEmail
  },
  getLoginType(state) {
    return state.loginType
  },
  /* sessionStorage stores everything as a string, so a stored `false` comes back as the
     truthy string 'false'. Compare explicitly instead of relying on truthiness. */
  getMicrosoftLogin(state) {
    return state.microsoftLogin === null
      ? sessionStorage.getItem('microsoftLogin') === 'true'
      : Boolean(state.microsoftLogin)
  },
  getGoogleLogin(state) {
    return state.googleLogin === null
      ? sessionStorage.getItem('googleLogin') === 'true'
      : Boolean(state.googleLogin)
  },
  getFeideLogin(state) {
    return state.feideLogin === null
      ? sessionStorage.getItem('feideLogin') === 'true'
      : Boolean(state.feideLogin)
  },
  getEducatorInfo(state) {
    return state.educatorInfo
  }
}
